export default {"src":"/_next/static/media/course-homework.2f876518.svg","height":28,"width":28};